<section class="content" style="padding: 0 !important;">
    <div class="content-block">
        <div class="row clearfix">
            <div class="col-lg-12 col-md-12">
                <div class="card" style="min-height: 500px;">
                    <div class="card-body p-3">

                        <!-- Historique direct -->
                        <div class="hospit-content">
                            <app-histo-hospitalisation (onNouvelleDemandeClick)="openDemandeModal()"></app-histo-hospitalisation>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- ================================================ -->
<!--  MODAL — Nouvelle demande d'hospitalisation       -->
<!-- ================================================ -->
@if (showDemandeModal) {
<div class="hospit-modal-backdrop" (click)="closeDemandeModal()">
    <div class="hospit-modal" (click)="$event.stopPropagation()">

        <div class="hospit-modal-header">
            <span class="hospit-modal-title">
                <i class="fas fa-hospital-user me-2"></i>Nouvelle demande d'hospitalisation
            </span>
            <button class="hospit-modal-close" (click)="closeDemandeModal()" title="Fermer">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <div class="hospit-modal-body">
            <div class="row g-0 h-100">
                <!-- ── Colonne bénéficiaire (sidebar) ── -->
                <div class="col-md-3 hospit-benef-col">
                    <app-benef-info [beneficiaireAutOselect]="beneficiaireAutOselect">
                        <app-search-form (sendUserInfo)="onSetUserInfo($event)"></app-search-form>
                    </app-benef-info>
                </div>
                <!-- ── Colonne formulaire ── -->
                <div class="col-md-9 hospit-form-col">
                    @if (!itemBeneficiare?.id) {
                    <div class="hospit-skeleton">
                        <div class="skel-header"></div>
                        <div class="row g-3 mt-1">
                            <div class="col-md-4">
                                <div class="skel-label"></div>
                                <div class="skel-input"></div>
                            </div>
                            <div class="col-md-4">
                                <div class="skel-label"></div>
                                <div class="skel-input"></div>
                            </div>
                            <div class="col-md-4">
                                <div class="skel-label"></div>
                                <div class="skel-input"></div>
                            </div>
                            <div class="col-12">
                                <div class="skel-label"></div>
                                <div class="skel-textarea"></div>
                            </div>
                        </div>
                        <div class="skel-btn mt-4"></div>
                    </div>
                    }
                    @if (itemBeneficiare?.id) {
                    <app-demande-hospitalisation [itemBeneficiare]="itemBeneficiare" (onCloseConsultationModal)="closeDemandeModal()"></app-demande-hospitalisation>
                    }
                </div>
            </div>
        </div>

    </div>
</div>
}